import styles from './VerificationBadges.module.css';

function VerificationBadges({ verificationStatus, planTier }) {
  if (!verificationStatus && !planTier) return null;

  const isSociallyVerified = verificationStatus?.hasLinkedSecondSocial || false;
  const isPsychometricallyVerified =
    verificationStatus?.hasCompletedFullTest || false;
  const isPro =
    planTier === 'pro' || planTier === 'founder' || planTier === 'vip';

  if (!isSociallyVerified && !isPsychometricallyVerified && !isPro) {
    return null;
  }

  return (
    <div className={styles.badgeContainer}>
      {isPro && (
        <div className={`${styles.badge} ${styles.pro}`}>
          <i className="fas fa-crown"></i> Pro Member
        </div>
      )}
      {isSociallyVerified && (
        <div className={`${styles.badge} ${styles.social}`}>
          <i className="fas fa-users"></i> Socially Verified
        </div>
      )}
      {isPsychometricallyVerified && (
        <div className={`${styles.badge} ${styles.gold}`}>
          <i className="fas fa-medal"></i> Psychometrically Verified
        </div>
      )}
    </div>
  );
}

export default VerificationBadges;
